<template>
  <div :id="id" :style="{ height: resolveHeight, width: resolveWidth }"></div>
</template>

<script setup lang="ts">
import type { EChartsOption } from 'echarts';

import useCustomChart from './hooks/useCustomChart';

interface Props {
  options: EChartsOption;
  height?: number | string;
  width?: number | string;
  responsiveWidth?: boolean;
  responsiveHeight?: boolean;
  eventType?: string;
  function?: Function;
}

const props = withDefaults(defineProps<Props>(), {
  options: undefined,
  height: 200,
  width: 300,
  responsiveWidth: false,
  responsiveHeight: false,
  eventType: 'dbClick',
  function: () => {},
});

const { id, resolveHeight, resolveWidth } = useCustomChart(props);
</script>
